
import { LOGIN_REQUEST,LOGIN_SUCCESS ,LOGIN_FAILURE,LOGOUT} from "./actionTypes";

const initialState = {
    isAuthenticated:false,
    token:"",
    loading: false,
    isError:false,
    errorMessage:"",
  };

  const authReducer = (state = initialState, {type,payload}) => {
    switch (type) {
      case LOGIN_REQUEST:
        return {
          ...state,
          loading:true,
        };
      case LOGIN_SUCCESS:
        return {
          ...state,
          isAuthenticated:true,
          token:payload,
          loading:false,
          isError:false,
          errorMessage:"",
        };
      case LOGIN_FAILURE:
        return {
          ...state,
          isAuthenticated:false,
          token:"",
          loading:false,
          isError:true,
          errorMessage:payload,
        };
        case LOGOUT:
          return { ...state,
            isAuthenticated: false, 
            token:"",
             error:""
             };
      default:
        return state;
    }
  };
  
  export default authReducer;
  

  